const objects = {
  serialize(value) {
    const seen = new WeakSet()

    const convert = (v) => {
      if (v === null || typeof v !== 'object') return v

      if (seen.has(v)) return '[Circular]'
      seen.add(v)

      // Date, RegExp, Error, Map, Set
      if (v instanceof Date) return v.toISOString()
      if (v instanceof RegExp) return v.toString()
      if (v instanceof Error) {
        return {
          name: v.name,
          message: v.message,
          stack: v.stack,
          ...extractProps(v),
        }
      }
      if (v instanceof Map) {
        return {
          type: 'Map',
          entries: Array.from(v.entries()).map(([k, val]) => [convert(k), convert(val)]),
        }
      }
      if (v instanceof Set) {
        return {
          type: 'Set',
          values: Array.from(v.values()).map(convert),
        }
      }

      return extractProps(v)
    }

    function extractProps(obj) {
      const out = {}

      // wszystkie własności, także niewenumerowalne + symbole
      const props = [...Object.getOwnPropertyNames(obj), ...Object.getOwnPropertySymbols(obj)]

      for (const key of props) {
        try {
          out[key] = convert(obj[key])
        } catch {
          out[key] = '[Unserializable]'
        }
      }

      return out
    }

    return JSON.stringify(convert(value))
  },
}

module.exports = objects
